/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { notification } from "antd";
import { fetchApi } from "../../_config/api";

import "./styles.less";
import {deepCopy, ENTERPRISEDEVELOPERROLE, getUserDetails} from "../../deps";
import {EyeOutlined} from "@ant-design/icons";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {Filters, PaginationSection, TableContent} from "../../library";
import {AddTeamPopup} from "./addteam";

export const Teams = ({ showLoader }) => {
  const { userRole  } = getUserDetails().profile || {};
  const { developerId } = getUserDetails().profile || {};
  const [activeData, setActiveData] = useState([]);
  const [suspendedData, setSuspendedData] = useState([]);
  const navigate = useNavigate()
  const [pageSetting, setSetting] = useState({
    page: 1,
    itemsPerPage: 5,
    pageActive: 1,
    itemsPerPageActive: 5,
    searchTextActive: "",
    searchTextSuspend: "",
    filterValue: "",
  });
  const [filteredData, setFilteredData] = useState([]);
  const [hitsListActive, setHitsListActive] = useState([]);
  const [hitsListSuspend, setHitsListSuspend] = useState([]);
  const [totalCountActive, setTotalCountActive] = useState(-1);
  const [totalCountSuspend, setTotalCountSuspend] = useState(-1);
  const startIndex = (pageSetting.page - 1) * pageSetting.itemsPerPage;
  const startIndexActive = (pageSetting.pageActive - 1) * pageSetting.itemsPerPageActive;
  const [isModalOpen, setIsModalOpen] = useState(false);


  const showModal = () => {
    setIsModalOpen(!isModalOpen);
  };
  const  location  = useLocation();
  useEffect(() => {
    if(location.state !==null){
      setIsModalOpen(true)
    }


  }, []);
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    setHitsListActive([5, 10, 15, 20, 25]);
  }, [activeData]);
  useEffect(() => {
    setHitsListSuspend([5, 10, 15, 20, 25]);
  }, [suspendedData]);

  useEffect(() => {
    onFilterDataChangeActive();
  }, [activeData, pageSetting]);
  useEffect(() => {
    onFilterDataChangeSuspend();
  }, [suspendedData, pageSetting]);


  useEffect(() => {
    getActiveTeamsList();
    getSuspendedTeamsList();
  }, []);

  const handleNavigation = (teamLock) => {
    navigate(`/developerDetails`, {
      state: {
        teamId: teamLock.teamId,
        teamName: teamLock.name,
      },
    });
  };
  const columns = [
    {
      title: "Team ID",
      dataIndex: "teamId",
      render: (_, { teamId,status,name }) => (
          status === "ACTIVE" ?  <Link to={"/edit-teams"} state={{teamId:teamId,teamName:name}}>
            {teamId}
          </Link> : teamId
      )
    },
    {
      title: "Team Name",
      dataIndex: "name",
    },
    {
      title: "Description",
      dataIndex: "desc",
    },
    {
      title: "Projects",
      dataIndex: "projectCount",
    },
    {
      title: "Developers",
      dataIndex: "developers",
      render: (_, { developers }) => <span>{developers?.length || 0}</span>,
    },

    {
      title: "Change Status",
      dataIndex: "status",
      render: (_, { _id, status }) => (
          <>
            {status === "ACTIVE"?
                <button className="save-changes-btn-difer"
                        onClick={() => setStatus(_id, status)}
                >
                  Deactivate
                </button>
                : status === "INACTIVE" ?
                    <button className="save-changes-btn-difer" style={{border:"1px solid green"}}
                            onClick={() => setStatus(_id, status)}
                    >
                      Activate
                    </button> :  null
            }
            </>

      ),
    },
    {
      title: "View",
      dataIndex: "",
      render: (_,teamLock) => (
          <a onClick={() => handleNavigation(teamLock)}>
            <EyeOutlined/>
          </a>
      ),
    },
  ];
  const columnsDeveloper = [
    {
      title: "Team ID",
      dataIndex: "teamId",
    },
    {
      title: "Team Name",
      dataIndex: "name",
    },
    {
      title: "Description",
      dataIndex: "desc",
    },
    {
      title: "Projects",
      dataIndex: "projectCount",
    },
    {
      title: "Developers",
      dataIndex: "developers",
      render: (_, { developers }) => <span>{developers?.length || 0}</span>,
    },
    {
      title: "Developer role in team",
      dataIndex: "developers",
      render: (_, { developers }) => {
        const matchedDeveloper = developers.find(
            (developer) => developer.developerId === developerId
        );
        return matchedDeveloper ? (matchedDeveloper.roleId === "ROLE6" ? "Maintainer" : "Contributor" ) : "";
      },
    },

  ];

  const setStatus = (id, status) => {
    showLoader(true);
    fetchApi({
      method: "PATCH",
      url: `teams/${id}`,
      data: { status: status === "ACTIVE"?"INACTIVE":"ACTIVE"},
      isDevApp: false,
    })
      .then((response) => {
       if(response.statusCode === 200 || response.statusCode === 201){
         getActiveTeamsList();
         getSuspendedTeamsList();
         notification.success({ message: "successfully Done", duration: 2 });
         showLoader(false);
       }else{
         notification.error({
           message: response.message,
           duration: 3,
         });
         showLoader(false);
       }
      })
      .catch(() => {
        notification.error({
          message: "Something went wrong. Please try again",
          duration: 3,
        });
        showLoader(false);
      });
  };

  const getActiveTeamsList = () => {
    const filter = {value:pageSetting.searchTextActive,status:"ACTIVE"}

    const Options = () => {
      return {
        sort: "",
        page: pageSetting.pageActive - 1,
        limit: pageSetting.itemsPerPageActive,
      };
    };

    let requestLink = `teams/getAll?options=${JSON.stringify(
      Options()
    )}&filter=${JSON.stringify(filter)}`;
    showLoader(true);
    fetchApi({ method: "GET", url: requestLink, isDevApp: false })
      .then((response) => {
        if (response.statusCode === 200 || response.statusCode === 201  ){
          const { docs = [] } = response;
          if(response.docs != null) {
            setActiveData([...docs]);
            showLoader(false);
          }else{
            setActiveData([]);
          }
        }
          setTotalCountActive(response.totalCount)
      })
      .catch(() => {
        showLoader(false);
        setActiveData([]);
      });
  };

  const getSuspendedTeamsList = () => {
    showLoader(true);
    const filter = {value:pageSetting.searchTextSuspend,status:"INACTIVE"}

    const Options = () => {
      return {
        sort: "",
        page: pageSetting.page - 1,
        limit: pageSetting.itemsPerPage,
      };
    };

    let requestLink = `teams/getAll?options=${JSON.stringify(
      Options()
    )}&filter=${JSON.stringify(filter)}`;

    fetchApi({ method: "GET", url: requestLink, isDevApp: false })
      .then((response) => {
        if (response.statusCode === 200 || response.statusCode === 201  ) {
          const {docs = []} = response;
          if (response.docs != null) {
            setSuspendedData([...docs]);
            showLoader(false);
          }
        }else{
          setSuspendedData([]);
        }
        setTotalCountSuspend(response.totalCount)
      })
      .catch(() => {
        showLoader(false);
      });
  };
  useEffect(() => {
    setTotalCountActive(totalCountActive);
  }, [activeData]);
  useEffect(() => {
    setTotalCountSuspend(totalCountSuspend);
  }, [suspendedData]);
  const onFilterDataChangeSuspend = () => {
    const endIndex =
        pageSetting.page * pageSetting.itemsPerPage > activeData.length
            ? activeData.length
            : pageSetting.page * pageSetting.itemsPerPage;

    const filterList = (
        pageSetting.searchTextSuspend
            ? activeData.filter((item) =>
                item.name
                    .toLowerCase()
                    .includes(pageSetting.searchTextSuspend.toLowerCase())
            )
            : deepCopy(activeData)
    )
        .slice(0, endIndex);
    setFilteredData(filterList);
  };
  const onFilterDataChangeActive = () => {
    const endIndex =
        pageSetting.pageActive * pageSetting.itemsPerPageActive > activeData.length
            ? activeData.length
            : pageSetting.pageActive * pageSetting.itemsPerPageActive;

    const filterList = (
        pageSetting.searchTextActive
            ? activeData.filter((item) =>
                item.name
                    .toLowerCase()
                    .includes(pageSetting.searchTextActive.toLowerCase())
            )
            : deepCopy(activeData)
    )
        .slice(0, endIndex);
    setFilteredData(filterList);
  };


  const onPageChangeActive = (pageNumber) => {
    pageSetting.pageActive = Number(pageNumber);
    setSetting({ ...pageSetting });
    getActiveTeamsList()
  };
  const onPerPageChangeActive = (value) => {
    pageSetting.itemsPerPageActive = Number(value);
    pageSetting.pageActive = 1;
    setSetting({ ...pageSetting });
    getActiveTeamsList()
  };
  const onTextChangeActive= (value) => {
    pageSetting.searchTextActive = value;
    setSetting({ ...pageSetting });
    getActiveTeamsList()

  };
  const lastActive =
      pageSetting.pageActive * pageSetting.itemsPerPageActive > totalCountActive
          ? totalCountActive
          : pageSetting.pageActive * pageSetting.itemsPerPageActive;

  const onPageChangeSuspend = (pageNumber) => {
    pageSetting.page = Number(pageNumber);
    setSetting({ ...pageSetting });
    getSuspendedTeamsList()
  };
  const onPerPageChangeSuspend = (value) => {
    pageSetting.itemsPerPage = Number(value);
    pageSetting.page = 1;
    setSetting({ ...pageSetting });
    getSuspendedTeamsList()
  };
  const onTextChangeSuspend= (value) => {
    pageSetting.searchTextSuspend = value;
    setSetting({ ...pageSetting });
    getSuspendedTeamsList()

  };
  const lastSuspend =
      pageSetting.page * pageSetting.itemsPerPage > totalCountSuspend
          ? totalCountSuspend
          : pageSetting.page * pageSetting.itemsPerPage;
  return (
      <div className="transaction-page-container">
        <div className="transaction-header-section">
          <div className="header-section">
            <div className="text">{`Active Teams`}</div>
          </div>
          <Filters
              btnText="Add Team"
              showCreateBtn={userRole !== ENTERPRISEDEVELOPERROLE}
              showFilters={false}
              value={pageSetting.searchTextActive}
              selectedValue={pageSetting.filterValue}
              onTextChange={onTextChangeActive}
              onNavigate={showModal}
          />
        </div>
        <div className="mt-n4" style={{marginLeft:"auto"}}><i className="ant-form-item-explain-warning">Search By Team Name,Description,Status</i></div>
        <div className="table-container">
          <TableContent  data={activeData}
                         columns={userRole === ENTERPRISEDEVELOPERROLE ? columnsDeveloper:columns}
                         pagination={false}
          />
          <PaginationSection
              last={lastActive}
              first={startIndexActive + 1}
              hitsList={hitsListActive}
              totalCount={totalCountActive}
              page={pageSetting.pageActive}
              itemsPerPage={pageSetting.itemsPerPageActive}
              onPageChange={onPageChangeActive}
              onPerPageChange={onPerPageChangeActive}
          />
        </div><br/>
          {
            userRole === ENTERPRISEDEVELOPERROLE ? <></> :
                <>
                <div className="transaction-header-section">
                  <div className="header-section">
                    <div className="text">{`Suspended Teams`}</div>
                  </div>
                  <Filters
                      showCreateBtn={false}
                      showFilters={false}
                      value={pageSetting.searchTextSuspend}
                      selectedValue={pageSetting.filterValue}
                      onTextChange={onTextChangeSuspend}
                  />
                </div>
                  <div className="mt-n4" style={{marginLeft:"auto"}}><i className="ant-form-item-explain-warning">Search By Team Name,Description,Status</i></div>
                <TableContent
                data={suspendedData}
                title="Suspended Teams"
                showAddBtn={false}
                columns={columns}
                pagination={false}
            /> <PaginationSection
                    last={lastSuspend}
                    first={startIndex + 1}
                    hitsList={hitsListSuspend}
                    totalCount={totalCountSuspend}
                    page={pageSetting.page}
                    itemsPerPage={pageSetting.itemsPerPage}
                    onPageChange={onPageChangeSuspend}
                    onPerPageChange={onPerPageChangeSuspend}
                />
                </>
          }

          <AddTeamPopup isModalOpen={isModalOpen}  reloadsus={getSuspendedTeamsList} reloadactive={getActiveTeamsList} handleCancel={handleCancel} />
      </div>

  );
};
